var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVec2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 244,
    viewBox: "0 0 448 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.211 244V216.515C419.211 216.515 435.368 236.001 419.211 244Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.209 243.995L389.667 225.408C389.667 225.408 422.246 230.695 420.209 243.995Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.649 8.37184C140.136 8.37184 142.963 6.49774 142.963 4.18592C142.963 1.8741 140.136 0 136.649 0C133.162 0 130.335 1.8741 130.335 4.18592C130.335 6.49774 133.162 8.37184 136.649 8.37184Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.601 19.0101C124.089 19.0101 126.916 17.136 126.916 14.8242C126.916 12.5124 124.089 10.6383 120.601 10.6383C117.114 10.6383 114.287 12.5124 114.287 14.8242C114.287 17.136 117.114 19.0101 120.601 19.0101Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59 207.839C120.077 207.839 122.904 205.965 122.904 203.653C122.904 201.341 120.077 199.467 116.59 199.467C113.102 199.467 110.275 201.341 110.275 203.653C110.275 205.965 113.102 207.839 116.59 207.839Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.454 239.037H325.586L325.193 221.749L332.454 221.476V239.037Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.213 243.455L312.055 243.455V243.265C312.057 241.749 312.967 240.295 314.584 239.223C316.201 238.151 318.394 237.548 320.681 237.546H334.213V243.455Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.769 233.792L365.473 235.611L354.691 219.867L361.183 217.694L371.769 233.792Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.732 243.246L355.618 243.071C355.165 242.383 354.921 241.642 354.9 240.892C354.88 240.141 355.082 239.394 355.496 238.696C355.91 237.997 356.528 237.359 357.314 236.818C358.1 236.277 359.04 235.844 360.078 235.544L372.482 231.96L376.044 237.376L355.732 243.246Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.658 102.569C352.877 102.569 359.54 98.152 359.54 92.7036C359.54 87.2553 352.877 82.8385 344.658 82.8385C336.44 82.8385 329.777 87.2553 329.777 92.7036C329.777 98.152 336.44 102.569 344.658 102.569Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.296 225.539L352.061 194.39L361.403 165.245L343.681 164.608L333.926 197.214L358.518 229.546L371.296 225.539Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.275 159.417L341.208 196.667L338.481 232.371L322.829 232.279L322.248 163.97L350.275 159.417Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.714 161.541L361.822 166.936L317.451 168.252L320.455 160.139L362.714 161.541Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.522 171.726C320.098 171.372 319.784 170.965 319.599 170.53C319.413 170.095 319.36 169.639 319.442 169.19C319.524 168.741 319.739 168.307 320.076 167.914C320.412 167.52 320.863 167.175 321.402 166.898C321.628 166.782 321.868 166.678 322.119 166.588L339.522 123.233L349.838 126.239L329.394 168.134C329.881 168.836 329.996 169.627 329.72 170.377C329.444 171.128 328.793 171.795 327.873 172.269C326.786 172.838 325.405 173.1 324.029 172.999C322.653 172.897 321.393 172.44 320.522 171.726Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.522 112.064L333.574 109.254C333.574 109.254 343.681 103.462 354.341 106.933L355.985 110.178L364.679 119.485L362.714 162.475C362.714 162.475 326.442 160.646 317.451 162.825L321.403 128.76L331.522 112.064Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41 166.623L318.095 163.783L332.258 134.438L333.541 118.054C333.615 117.227 333.95 116.419 334.525 115.683C335.1 114.946 335.901 114.298 336.877 113.78C338.054 113.148 339.414 112.684 340.874 112.418C342.333 112.151 343.86 112.087 345.359 112.23C350.364 112.685 354.045 115.222 354.112 118.263L354.112 118.277L354.109 118.292L349.191 141.256L347.613 144.994L333.41 166.623Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.404 100.436L354.791 101.004L359.925 97.3855C359.925 97.3855 369.361 82.8754 348.506 80.655C327.651 78.4346 332.205 84.0403 329.417 87.5557L337.939 89.0245L345.609 94.2219C345.609 94.2219 350.613 91.7918 352.085 93.9959C353.557 96.2001 351.404 100.436 351.404 100.436Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.743 184.592H0V30.3018H232.743V184.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.743 184.592H0V30.3018H232.743V184.592ZM3.43876 182.312H229.305V32.5814H3.43876V182.312Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 96.6292H47.9884V100.122H197.254V96.6292Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 105.711H47.9884V109.204H197.254V105.711Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 114.793H47.9884V118.286H197.254V114.793Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9281 101.167C40.8273 101.167 42.3668 100.147 42.3668 98.8875C42.3668 97.6285 40.8273 96.6079 38.9281 96.6079C37.0289 96.6079 35.4893 97.6285 35.4893 98.8875C35.4893 100.147 37.0289 101.167 38.9281 101.167Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 57.4956H47.9884V60.9886H197.254V57.4956Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 66.5775H47.9884V70.0705H197.254V66.5775Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 75.6593H47.9884V79.1523H197.254V75.6593Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9281 61.6536C40.8273 61.6536 42.3668 60.633 42.3668 59.374C42.3668 58.115 40.8273 57.0944 38.9281 57.0944C37.0289 57.0944 35.4893 58.115 35.4893 59.374C35.4893 60.633 37.0289 61.6536 38.9281 61.6536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 136.143H47.9884V139.636H197.254V136.143Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 145.225H47.9884V148.718H197.254V145.225Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.254 154.306H47.9884V157.799H197.254V154.306Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9281 140.301C40.8273 140.301 42.3668 139.28 42.3668 138.021C42.3668 136.762 40.8273 135.741 38.9281 135.741C37.0289 135.741 35.4893 136.762 35.4893 138.021C35.4893 139.28 37.0289 140.301 38.9281 140.301Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.427 243.903H276.062C275.91 243.903 275.764 243.863 275.657 243.791C275.549 243.72 275.489 243.623 275.489 243.523C275.489 243.422 275.549 243.325 275.657 243.254C275.764 243.183 275.91 243.143 276.062 243.143H447.427C447.579 243.143 447.725 243.183 447.832 243.254C447.94 243.325 448 243.422 448 243.523C448 243.623 447.94 243.72 447.832 243.791C447.725 243.863 447.579 243.903 447.427 243.903Z",
    fill: "#CBCBCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 244,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVec2);
export default __webpack_public_path__ + "static/media/vec2.c2023ad3ee8198afe847a2a5846f3dbb.svg";
export { ForwardRef as ReactComponent };